// extracted by mini-css-extract-plugin
export default {"container":"_5yXV3","mobile":"e4HY1"};